import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IApprovalState } from "./definitions";

const initialState: IApprovalState = {
  selectedApproval: undefined,
  hasApprovalLoadingError: false,
  isApprovalLoading: false,
  approvalError: null,
};

export const approvalSlice = createSlice({
  name: "approval",
  initialState,
  reducers: {
    setSelectedApproval: (state, action) => {
      return {
        ...state,
        selectedApproval: { ...action.payload },
      };
    },
    removeSelectedApproval: (state) => {
      state.selectedApproval = null;
    },
    setHasApprovalLoadingError: (state, action) => {
      return {
        ...state,
        hasApprovalLoadingError: action.payload,
      };
    },
    setIsApprovalLoading: (state, action) => {
      return {
        ...state,
        isApprovalLoading: action.payload,
      };
    },
    setApprovalError: (state, action) => {
      return {
        ...state,
        approvalError: action.payload,
      };
    },
  },
});

export const {
  setSelectedApproval,
  removeSelectedApproval,
  setHasApprovalLoadingError,
  setIsApprovalLoading,
  setApprovalError,
} = approvalSlice.actions;

export default approvalSlice.reducer;
